import { Container } from "react-bootstrap";
import { Form } from "@/ui/Form";
import { useLocale } from "@/hooks/useLocale";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicText } from "@/ui/DynamicText";
import { DynamicHtml } from "@/ui/DynamicHtml";
import { useLink } from "@/hooks/useLink";
import sourceflowEnums from "@/sourceflow.enums";

export const RecruitmentPageFormSection = ({ className }) => {
  const locale = useLocale();
  const link = useLink();

  const onSubmitDone = () => {
    if (typeof window !== "undefined") {
      window.location.href = "/survey-request-completed-thank-you-page";
    }
  };
  return (
    <div className={className}>
      <Container className="px-0">
        <div id="form" className={clsx(classes.form, "mb-4 p-4 p-md-5")}>
          <DynamicText path={`page.recruitment.form.title.${locale}`} tag="h4" className="mb-2" />
          <DynamicHtml path={`page.recruitment.form.text.${locale}`} className="mb-4" />
          <Form className="mb-4" formId={sourceflowEnums.forms.recruitment[locale]} onSubmitDone={onSubmitDone} />
        </div>
      </Container>
    </div>
  );
};
